import { API_BASE_LOGIN } from "../../../constants";
import { setLocalStorageItem } from "../../storage";

export const loginUser = async (userData) => {
    const body = JSON.stringify(userData);
    const method = 'POST';
    
    try {
        const response = await fetch(API_BASE_LOGIN, {
            headers: {
                'Content-Type': 'application/json',
            },
            method,
            body,
        });

        const result = await response.json();

        if(response.status === 200) {

            const {jwt, ...user} = result;
            setLocalStorageItem('vp-portal-token', jwt);
            setLocalStorageItem('vp-portal-user', user);
            return response;
        } else {
            return response;
        } 
    } catch(error) {
        console.error(error);
    }
};

export default loginUser;

// const method = 'POST';

// export async function login(user) {
//     const url = `${API_BASE_LOGIN}`;
//     const body = JSON.stringify(user);
  
//     const response = await fetch(url, {
//       headers: {
//         'Content-Type': 'application/json'
//       },
//       method,
//       body,
//     })
  
//     const result = await response.json();
//     const token = result.jwt;
//     const user = result.user;
//     console.log(user);
  
//     storage.saveToLocal("jwt", token);
//     storage.saveToLocal("profile", user);
      
//       if (response.status === 200) {
//           alert("Du er nå logget inn!");
//         if(user.isCoach === false){
//           window.location.href="/user/home/";
//         }else if(user.isCoach === true){
//           window.location.href="/coach/home/";
//         }
//       }else if(response.ok != true) {
//           alert(`Ops! Noe gikk feil! Vennligst prøv igjen`)
//          // location.reload();
//       }
//   }
//   //login(testUser);